"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omit;

function omit(source = {}, omittedProperties = []) {
  return Object.keys(source).reduce((result, key) => {
    if (omittedProperties.indexOf(key) === -1) {
      result[key] = source[key];
    }

    return result;
  }, {});
}